module.exports = __webpack_public_path__ + "assets/img/s3-subtitle-4-1efef214.png";